import React from 'react'
import { Flex } from 'hljd'
import { Button } from 'hljd'
import Img from '@UI/Img'
import Style from './style.module.less'

export default ({
  item,
  onApply,
  selectedKey,
  selectedText,
  unSelectedText,
  onClick,
  highlightText = ''
}) => {
  let { id, name, fullAddress, logoPath } = item

  if (highlightText) {
    const regex = new RegExp(`${highlightText}`, 'ig')
    name = name.replace(
      regex,
      match => `<span style="color: #448afc">${match}</span>`
    )
  }

  return (
    <Flex className={Style.item} sp>
      <Flex
        onClick={() => {
          onClick && onClick()
        }}
        className={Style.info}
      >
        <Img className={Style.img} src={logoPath} />
        <div>
          <div
            className={Style.name}
            dangerouslySetInnerHTML={{ __html: name }}
          />
          <div className={Style.address}>{fullAddress}</div>
        </div>
      </Flex>

      <Button
        type="primary"
        disabled={item[selectedKey]}
        onClick={() => onApply(id)}
      >
        {item[selectedKey] ? selectedText : unSelectedText}
      </Button>
    </Flex>
  )
}
